/* istanbul ignore file */
import { optional as codecOptional } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CreatePlagiarismRunData } from './CreatePlagiarismRunData';
const CreatePlagiarismRunAssignmentDataParser = 
/* #__PURE__ */ parsers.object([
    ['json', CreatePlagiarismRunData],
    ['baseCode', /* #__PURE__ */ codecOptional(parsers.file), 'base_code'],
    ['oldSubmissions', /* #__PURE__ */ codecOptional(parsers.file), 'old_submissions'],
]);
export class CreatePlagiarismRunAssignmentData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreatePlagiarismRunAssignmentDataParser.decode(input).map(res => new CreatePlagiarismRunAssignmentData(res));
    }
    static unsafeDecode(input) {
        return CreatePlagiarismRunAssignmentData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreatePlagiarismRunAssignmentDataParser.encode(data);
    }
    static schema() {
        return CreatePlagiarismRunAssignmentDataParser.schema();
    }
}
